// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2EWPA","right":"Footer_right__AmVuk","buttons":"Footer_buttons__18F-b"};